import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { OrganizationKey } from '../models/OrganizationKey';

export class OrganizationKeyMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): OrganizationKey {
    const information = data.information?.length > 0 ? data.information : null;
    return new OrganizationKey(this.gqlIdEncoder.decode(data.id), data.shortDescription, information, data.reportKeys?.totalCount ?? 0);
  }
}
